export const QUERY_FLATFILE_UPLOAD_JOB = "QUERY_FLATFILE_UPLOAD_JOB";
